var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.7275 11.704H46.1895V8.68506H47.7275C48.5611 8.68506 49.237 9.36091 49.237 10.1945C49.237 11.0282 48.5611 11.704 47.7275 11.704Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.6407 5.89963L28.6385 5.90231L28.6407 5.89953L30.9729 3.0987C32.6077 1.13532 35.0304 0 37.5853 0C42.3374 0 46.1898 3.85232 46.1898 8.60452V20.6183C46.1898 40.7401 21.5283 39.9743 21.2275 39.9642H21.2754C25.6757 37.4763 28.6407 32.1996 28.6407 27.0645V5.89963ZM38.0985 11.1788C39.2031 11.1788 40.0985 10.2834 40.0985 9.17885C40.0985 8.07428 39.2031 7.17885 38.0985 7.17885C36.9939 7.17885 36.0985 8.07428 36.0985 9.17885C36.0985 10.2834 36.9939 11.1788 38.0985 11.1788Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.635 8.30811V26.6849C26.0534 32.5331 22.776 37.4763 18.3757 39.9642H0.149414L26.635 8.30811ZM16.7819 29.6623C17.3337 29.0376 18.2877 28.9785 18.9126 29.5304C19.5373 30.0822 19.5965 31.0361 19.0446 31.6609L11.7102 39.9641H7.72139C7.77053 39.8797 7.82827 39.7987 7.89538 39.7227L16.7819 29.6623Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.af29c46efb3822b6bcbee5d1efe062c7.svg";
export { ForwardRef as ReactComponent };